import { useSelector } from 'react-redux';

import { apiSlice } from './apiSlice';

// API Slice
export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAccount: builder.query({
      query: ({ id }) => `/accounts/${id}`,
    }),
  }),
});

// API Selectors
export const selectAccountResult = extendedApiSlice.endpoints.getAccount.select;

// API Hooks
export const { useGetAccountQuery } = extendedApiSlice;

// Data Hook
export const useAccountData = ({ accountId }) => {
  const { data: account, error, isLoading: loading } = useSelector(selectAccountResult({ id: accountId }));

  return {
    account: account,
    error: error,
    loading: loading,
  };
};
